"use client";
import ImageCommon from "@/src/component/image/image";
import { notFound, usePathname } from "next/navigation";
import { Row, Col, Collapse, Button } from "antd";
import "./style.scss";
import Image from "next/image";
import tickIcon from "@/public/icon/tick-icon.svg";
import promotionTagIcon from "@/public/icon/promotion-tag-icon.svg";
import iconStar from "@/public/icon/icon-start-3d.svg";
import BreadcrumbCustom from "@/src/component/detail/breadcrumb";
import iconArrow from "@/public/icon/ChevronDownWhite.svg";
import chevronDown from "@/public/icon/chevron-down.png";
import Link from "next/link";
import { convertToMillionRange } from "@/src/util/util";
import useWindowSize from "@/src/hooks/useWindowSize";
import { useEffect, useState } from "react";
import FormChatBotMobile from "@/src/component/dialog/form-chat-bot-mobile";
import { Modal } from "antd";
import Chatbox from "@/src/component/detail/chatbox";
import { DateTime } from "luxon";
import ContactSection from "@/src/component/tim-phong-kham/contact-section";
import { ClinicItem, BrandItem } from "./clinic-item";
import { useRouter } from "next/navigation";
import { wrapperRouterPush } from "@/src/util/util";

const { Panel } = Collapse;

const LandingPageClient = ({ data }) => {
  const pathName = usePathname();
  const { width } = useWindowSize();
  const [expanded, setExpanded] = useState(false);
  const [openBooking, setOpenBooking] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const [clinicDetail, setClinicDetail] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const router = useRouter();
  let dataClinic;

  useEffect(() => {
    const width = window.innerWidth;
    setIsMobile(width < 768);
  }, [width]);

  // const breadcrumb = [
  //   { label: "Trang Chủ", href: "/" },
  //   { label: "Phòng khám", href: "/phong-kham" },
  //   data?.type == "PROVINCE"
  //     ? {
  //         label: data?.province?.name,
  //         href: `/phong-kham/${data?.slug}`,
  //       }
  //     : {
  //         label: data?.province?.name,
  //         href: `/phong-kham/${data?.parent?.slug}`,
  //       },
  //   data?.type != "PROVINCE"
  //     ? {
  //         label: data?.district?.name || data?.category_service?.name,
  //         href: `/phong-kham/${data?.parent?.slug}/${data?.slug}`,
  //       }
  //     : null,
  // ].filter(Boolean);
  const breadcrumb = [
    { label: "Trang Chủ", href: "/" },
    { label: "Phòng khám", href: "/phong-kham" },
  ];

  if (data) {
    const isProvince = data.type === "PROVINCE";

    breadcrumb.push({
      label:
        data.province.name == "Hồ Chí Minh"
          ? "TP. Hồ Chí Minh"
          : data.province.name,
      href: `/phong-kham/${isProvince ? data.slug : data.parent.slug}`,
    });

    if (!isProvince) {
      breadcrumb.push({
        label: data.district?.name || data.category_service?.name,
        href: `/phong-kham/${data.parent.slug}/${data.slug}`,
      });
    }
  }

  if (data.type == "DISTRICT") {
    dataClinic = data.brand
      .flatMap((brand) => brand.clinic)
      .sort(
        (a, b) =>
          b?.rating_overview?.overall_average -
          a?.rating_overview?.overall_average
      );
  }

  const currentMonthYear = DateTime.now().toFormat("MM/yyyy");
  return (
    <>
      <div className="landing-page">
        <div>
          <BreadcrumbCustom items={breadcrumb} />
          <h1>
            [{currentMonthYear}] {data.title}
          </h1>
          <p
            dangerouslySetInnerHTML={{ __html: data.description }}
            className="landing-page__description"
          />
        </div>

        {/* clinic */}
        <div className="landing-page__clinic">
          {data.type == "DISTRICT"
            ? dataClinic?.map((clinic) => {
                return (
                  <ClinicItem
                    clinic={clinic}
                    type={data.type}
                    service_id={data?.category_service_id}
                    setClinicDetail={setClinicDetail}
                    setOpenContact={setOpenContact}
                    setOpenBooking={setOpenBooking}
                  />
                );
              })
            : data.brand?.map((brand) => {
                if (brand.clinic.length > 0) {
                  return (
                    <BrandItem
                      brand={brand}
                      type={data.type}
                      service_id={data?.category_service_id}
                      province_name={data.province.name}
                      setClinicDetail={setClinicDetail}
                      setOpenContact={setOpenContact}
                      setOpenBooking={setOpenBooking}
                    />
                  );
                }
              })}
          <Button
            onClick={() => wrapperRouterPush(router, "/tim-phong-kham")}
            className="landing-page__clinic-btn"
          >
            Tìm các phòng khám khác
          </Button>
        </div>

        {/* khu-vuc-lan-can */}
        {data?.near_by_area?.length > 0 && (
          <div className="landing-page__near-by-areas">
            <h2 className="landing-page__title">
              THAM KHẢO CÁC KHU VỰC LÂN CẬN
            </h2>
            <Row gutter={isMobile ? [0, 15] : [50, 30]}>
              {data.near_by_area.map((item, index) => (
                <Col xs={24} md={12} lg={8} key={index}>
                  <Link
                    href={`/phong-kham/${data?.parent?.slug || data.slug}/${
                      item.slug
                    }`}
                    className="landing-page__link-item"
                  >
                    <h3>Nha khoa tại {item.name}</h3>
                    <Image
                      src={chevronDown}
                      alt="icon"
                      className="landing-page__link-item-icon"
                    />
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {/* dich-vu */}
        {data?.suggested_service?.length > 0 && data.type != "SERVICE" && (
          <div className="landing-page__near-by-areas">
            <h2 className="landing-page__title">THAM KHẢO CÁC DỊCH VỤ</h2>
            <Row gutter={isMobile ? [0, 15] : [50, 30]}>
              {data.suggested_service.map((item, index) => (
                <Col xs={24} md={12} lg={8} key={index}>
                  <Link
                    href={`/phong-kham/${data?.parent?.slug || data.slug}/${
                      item.slug
                    }`}
                    className="landing-page__link-item"
                  >
                    <h3>
                      {item.name} tại{" "}
                      {data.province.name == "Hồ Chí Minh"
                        ? "TP. Hồ Chí Minh"
                        : data.province.name}
                    </h3>
                    <Image
                      src={chevronDown}
                      alt="icon"
                      className="landing-page__link-item-icon"
                    />
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {/* content */}
        <div className="landing-page__content">
          <p
            className={`landing-page__content-text ${
              expanded ? "expanded" : ""
            }`}
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
          <button
            className="landing-page__content-btn"
            onClick={() => setExpanded((prev) => !prev)}
          >
            <span>{expanded ? "Thu gọn" : "Xem thêm"}</span>
            <Image
              src={chevronDown}
              alt="icon"
              width={13}
              height={13}
              style={{
                transform: `rotate(${expanded ? -90 : 90}deg)`,
                transition: "transform 0.3s ease",
              }}
            />
          </button>
        </div>

        {/* bai-viet-lien-quan */}
        {data?.related_blogs?.length > 0 && (
          <div className="landing-page__related-blogs">
            <h2 className="landing-page__title">BÀI VIẾT LIÊN QUAN</h2>
            <ul>
              {data.related_blogs.map((item, index) => (
                <li key={index}>
                  <Link href={`/blog/${item.slug}`}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* faq */}
        <div className="landing-page__faq">
          <h2 className="landing-page__title">Câu hỏi thường gặp</h2>
          <Collapse
            accordion
            expandIconPosition="end"
            bordered={false}
            expandIcon={({ isActive }) => (
              <div
                style={{
                  transform: `rotateX(${isActive ? 0 : 180}deg)`,
                }}
              >
                <Image
                  src={iconArrow}
                  width={25}
                  height={25}
                  className="collapse-expand-icon"
                  alt="icon"
                />
              </div>
            )}
          >
            {data?.faq?.map((item, index) => {
              return (
                <Panel
                  header={
                    <>
                      <div className="wp-faq__index">{index + 1}</div>
                      <h3>{item.question}</h3>
                    </>
                  }
                  key={item.id}
                  style={{ border: "none", marginBottom: "16px" }}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                </Panel>
              );
            })}
          </Collapse>
        </div>
      </div>

      <ContactSection />
      <Modal
        className="wpModalChatBox"
        open={openBooking}
        footer={null}
        closable={true}
        width={380}
        centered
        style={{ top: 10 }}
        destroyOnClose={true}
        onCancel={() => {
          setOpenBooking(false);
        }}
      >
        <div style={{ position: "relative" }}>
          <Chatbox detailClinic={clinicDetail} isModal={true} />
        </div>
      </Modal>
      <Modal
        className="modal-chatbot-mobile"
        open={openContact}
        onCancel={() => {
          setOpenContact(false);
        }}
        footer={null}
        closable={true}
        width={380}
        destroyOnClose={true}
        centered
      >
        <FormChatBotMobile clinic={clinicDetail} />
      </Modal>
    </>
  );
};

export default LandingPageClient;
